export default __webpack_public_path__ + "static/logo_original-902e78d97a80233d8b46b912bb31f181.svg";